"use client";

import { Hero } from "./hero";
import { ExecutiveSummary } from "./executive-summary";
import { ContactForm } from "./contact-form";
import { Offices } from "./offices";
import { GeneralInquiries } from "./general-inquiries";
import { SalesInquiries } from "./sales-inquiries";
import { PartnerInquiries } from "./partner-inquiries";
import { MediaInquiries } from "./media-inquiries";
import { TechSupport } from "./tech-support";
import { CareersContact } from "./careers-contact";
import { DemoRequests } from "./demo-requests";
import { Consultation } from "./consultation";
import { Trust } from "./trust";
import { ResponseTimes } from "./response-times";
import { Channels } from "./channels";
import { WhyContact } from "./why-contact";
import { ContactFaq } from "./faq";
import { ContactCta } from "./cta";

export function ContactPage() {
  return (
    <>
      <Hero />
      <div className="bg-aurora-crimson">
        <ExecutiveSummary />
      </div>
      <ContactForm />
      <div className="bg-aurora-cyan">
        <Offices />
      </div>
      <GeneralInquiries />
      <div className="bg-aurora-emerald">
        <SalesInquiries />
      </div>
      <PartnerInquiries />
      <div className="bg-aurora-amber">
        <MediaInquiries />
      </div>
      <TechSupport />
      <div className="bg-aurora-crimson">
        <CareersContact />
      </div>
      <DemoRequests />
      <div className="bg-aurora-purple">
        <Consultation />
      </div>
      <Trust />
      <div className="bg-aurora-emerald">
        <ResponseTimes />
      </div>
      <Channels />
      <div className="bg-aurora-cyan">
        <WhyContact />
      </div>
      <ContactFaq />
      <ContactCta />
    </>
  );
}
